<template>
  <div id="app">
    <router-view @hasLogin="hasLogin" />
  </div>
</template>

<script>
import { initAuthorMenuMixin } from '@/util/mixin'
import Sessionstorage from '@/util/sessionstorage'

export default {
  name: 'app',
  mixins: [initAuthorMenuMixin],
  data() {
    return {
      flag: false
    }
  },
  created() {

    // 清除权限缓存
    Sessionstorage.clearMenuRootlist()
    Sessionstorage.clearSystemRoles()
  },
  methods: {
    hasLogin() {
      // 初次登录调用
      this.flag = true
      this.renderCurrentAuthorMenu()
    }
  },
  watch: {
    $route(to ,from) {
      if (to.name !== 'dingding' && !this.flag) {
        this.renderCurrentAuthorMenu()
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/style/public-class.scss';
</style>
